import {
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  LOGOUT,
  SERVER_ERROR,
  INVALID_EMAIL_FORMAT,
  CLEAR_LOGIN_ERROR,
  REFRESH_ACCESS_TOKEN_REQUEST,
  REFRESH_ACCESS_TOKEN_SUCCESS,
  REFRESH_ACCESS_TOKEN_FAILURE,
  CREATE_PASSWORD_REQUEST,
  CREATE_PASSWORD_SUCCESS,
  CREATE_PASSWORD_FAILURE,
  CLEAR_CREATE_PASSWORD_ERROR,
  CHANGE_PASSWORD_REQUEST,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_FAILURE,
  CLEAR_CHANGE_PASSWORD_ERROR,
  RESET_PASSWORD_REQUEST,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_FAILURE,
  CLEAR_RESET_PASSWORD_ERROR,
} from "../actions/authActionTypes";
import { getItem } from "../../../components/utilities/UtilityFunctions";
import Cookies from 'js-cookie';

const initialState = {
  loggedInUserRolePermissions: JSON.parse(
    localStorage.getItem("loggedInUserRolePermissions") || "[]",
  ), // Initialize from localStorage to persist role permissions on reload
  isLoggedIn: JSON.parse(getItem('isLoggedIn')) || false,
  accessToken: localStorage.getItem('accessToken') || null,
  loginError: null,
  serverError: null,
  invalidEmailError: null,
  createPasswordSuccess: null,
  createPasswordError: null,
  changePasswordSuccess: null,
  changePasswordError: null,
  resetPasswordSuccess: null,
  resetPasswordError: null,
  invalidResetPasswordTokenError: null,
  invalidCreatePasswordTokenError: null,
  refreshTokenError: null,
  loadingTokenRefresh: null,
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_SUCCESS:
      return {
        ...state,
        isLoggedIn: true,
        accessToken: action.payload.accessToken,
        loggedInUserRolePermissions: action.payload.rolePermissions,
        loginError: null,
        serverError: null,
        invalidEmailError: null,
        changePasswordError: null, // Clear change password errors on login
        resetPasswordError: null, // Clear reset password errors on login
      };

    case LOGIN_FAILURE:
      return {
        ...state,
        isLoggedIn: false,
        accessToken: null,
        loggedInUserRolePermissions: [],
        loginError: action.payload,
        serverError: null,
        invalidEmailError: null,
      };

    case CLEAR_LOGIN_ERROR:
      return {
        ...state,
        loginError: null,
      };

    case SERVER_ERROR:
      return {
        ...state,
        isLoggedIn: false,
        loginError: null,
        serverError: action.payload,
        invalidEmailError: null,
      };

    case INVALID_EMAIL_FORMAT:
      return {
        ...state,
        isLoggedIn: false,
        loginError: null,
        serverError: null,
        invalidEmailError: action.payload,
      };

    case RESET_PASSWORD_REQUEST:
      return {
        ...state,
        resetPasswordSuccess: null,
        resetPasswordError: null,
      };

    case RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        resetPasswordSuccess: action.payload,
        resetPasswordError: null,
      };

    case RESET_PASSWORD_FAILURE:
      return {
        ...state,
        resetPasswordSuccess: null,
        resetPasswordError: action.payload,
      };

    case CLEAR_RESET_PASSWORD_ERROR:
      return {
        ...state,
        resetPasswordError: null,
      };

    case CREATE_PASSWORD_REQUEST:
      return {
        ...state,
        createPasswordSuccess: null,
        createPasswordError: null,
        invalidCreatePasswordTokenError: null, // Clear token-specific error
      };

    case CREATE_PASSWORD_SUCCESS:
      return {
        ...state,
        createPasswordSuccess: true, // Simplified to a boolean since LOGIN_SUCCESS handles user data
        createPasswordError: null,
        invalidCreatePasswordTokenError: null,
      };

    case CREATE_PASSWORD_FAILURE:
      return {
        ...state,
        createPasswordSuccess: null,
        createPasswordError: action.payload,
        invalidCreatePasswordTokenError: action.payload.includes('token') ? action.payload : null, // Set token-specific error if relevant
      };

    case CLEAR_CREATE_PASSWORD_ERROR:
      return {
        ...state,
        createPasswordError: null,
        invalidCreatePasswordTokenError: null,
      };

    case LOGOUT:
      return {
        ...state,
        isLoggedIn: false,
        accessToken: null,
        loggedInUserRolePermissions: [],
        loginError: null,
        serverError: null,
        invalidEmailError: null,
        changePasswordError: null,
        resetPasswordError: null,
        invalidResetPasswordTokenError: null,
        refreshTokenError: null,
      };

    case REFRESH_ACCESS_TOKEN_REQUEST:
      return {
        ...state,
        loadingTokenRefresh: true,
      };

    case REFRESH_ACCESS_TOKEN_SUCCESS:
      return {
        ...state,
        accessToken: action.payload,
        loadingTokenRefresh: false,
        refreshTokenError: null,
      };

    case REFRESH_ACCESS_TOKEN_FAILURE:
      return {
        ...state,
        loadingTokenRefresh: false,
        refreshTokenError: action.payload,
        isLoggedIn: false,
      };

    default:
      return state;
  }
};

export default authReducer;

// Built and maintained by Jerry Jaweh Tiehn



                            // Built and maintained by Jerry Jaweh Tiehn